// A15 — THE HEADER-COLUMN FINDER. Brief 65 (brief 50 §4), the eleventh of the sixteen.
//
// Which column of a spreadsheet's header row carries one of these names,
// case-insensitively and whitespace-forgivingly, or -1. Five copies, and every
// pair among them is 100.0%:
//
//   src/views/CaseView.tsx:176-181@8fdbbd6c          `findC`
//   src/views/CollectiveCaseView.tsx:271-276@8fdbbd6c  `findC`
//   src/views/CollectiveCaseView.tsx:1741-1746@8fdbbd6c `findC`
//   src/App.tsx:821-826@8fdbbd6c                     `findC2`
//   src/components/TimeExcel.tsx:40-45@8fdbbd6c      `findCol`
//
// IDENTICAL MODULO THE NAMES OF THE THINGS INSIDE — `h`/`headers`, `lw`/`lowers`,
// `x`/`h` — and one copy's indentation, which is only that it was declared
// inside a function rather than at module scope. Nothing to parameterise.
//
// This is the ONE band-A candidate the block-level harness could have frozen:
// of the 319 spans docs/extraction-candidates.md cites, three are `reachable`
// and they are three of these five. It is extracted here on the strength of the
// DOM snapshot like every other row, which is ruling 62d in practice — the
// locator was never what stood between the sweep and its safety.
// 166 §G — TYPED, and the reason is a chain rather than tidiness: `h: any`
// made the RETURN `any` too, so every `vals[dateIdx]` at every call site was an
// unsafe computed access. A header row is a list of cells and the names are
// words; the answer is an index.
/** A header row's cell, as `sheet_to_json` hands one over. */
export type HeaderCell = string | number | null | undefined;
export const findHeaderCol = (h: readonly HeaderCell[], ...names: string[]): number => {
  const lw = names.map((n) => n.toLowerCase());
  return h.findIndex((x) =>
    lw.includes((x || "").toString().toLowerCase().trim()),
  );
};
